import i18n from '@/base/i18n/index'
import { payerPaywallGuard } from '@/base/utils/payerPaywallGuard'

const MaintenanceComponent = () => import('@/base/views/Maintenance.vue')
const StartComponent = () => import('@/base/views/Start.vue')
const PayerPaywallComponent = () => import('@/base/views/PayerPaywall.vue')
const ResultComponent = () => import('@/base/views/Result.vue')
const VisadataComponent = () => import('@/base/views/Visadata.vue')
const ThankYouComponent = () => import('@/base/views/ThankYou.vue')
const ContinueComponent = () => import('@/base/views/Continue.vue')
const WaitComponent = () => import('@/base/views/Wait.vue')
const ErrorNotFoundComponent = () => import('@/base/views/404.vue')
const ErrorComponent = () => import('@/base/views/Error.vue')
const ConfirmationComponent = () => import('@/base/views/Confirmation.vue')
const SecureBackComponent = () => import('@/base/views/SecureBack.vue')
const RegulationsApprovalComponent = () => import('@/base/views/RegulationsApproval.vue')
const SessionTimeoutComponent = () => import('@/base/views/SessionTimeout.vue')
const PaywayErrorComponent = () => import('@/base/views/PaywayError.vue')

export const ROUTING = {
  start: '/start',
  continue: '/continue',
  payerPaywall: '/payer-paywall',
  wait: '/wait',
  confirmation: '/confirmation',
  result: '/result',
  thankYou: '/thank-you',
  error: '/error',
  visadata: '/visadata',
  errorNotFound: '/error/404',
  secureBack: '/secure-back',
  maintenance: '/maintenance',
  regulationsApproval: '/regulations-approval',
  sessionTimeout: '/session-timeout',
  paywayError: '/payway-error',
}

export const routes = [
  {
    path: ROUTING.maintenance,
    name: 'Maintenance',
    component: MaintenanceComponent,
    meta: {
      title: 'maintenance',
    },
  },
  {
    path: ROUTING.start + '/:apiToken',
    name: 'Start',
    component: StartComponent,
    props: true,
    meta: {
      title: 'start',
    },
  },
  {
    path: ROUTING.payerPaywall,
    name: 'PayerPaywall',
    component: PayerPaywallComponent,
    beforeEnter: payerPaywallGuard,
    meta: {
      title: 'payer-paywall',
    },
  },
  {
    path: ROUTING.result + '/:apiToken',
    name: 'Result',
    component: ResultComponent,
    props: true,
    meta: {
      title: 'result',
    },
  },
  {
    path: ROUTING.visadata + '/:apiToken/:idTransRemote',
    name: 'Visadata',
    component: VisadataComponent,
    props: true,
    meta: {
      title: 'visadata',
    },
  },
  {
    path: ROUTING.thankYou + '/:apiToken',
    name: 'ThankYou',
    component: ThankYouComponent,
    props: true,
    meta: {
      title: 'thankYou',
    },
  },
  {
    path: ROUTING.continue + '/:idTransRemote/:continueHash',
    name: 'Continue',
    props: true,
    component: ContinueComponent,
    meta: {
      title: 'continue',
    },
  },
  {
    path: ROUTING.wait + '/:apiToken/:idTransRemote',
    name: 'Wait',
    props: true,
    component: WaitComponent,
    meta: {
      title: 'wait',
    },
  },
  {
    path: ROUTING.errorNotFound,
    name: 'ErrorNotFound',
    props: true,
    component: ErrorNotFoundComponent,
    meta: {
      title: 'errorNotFound',
    },
  },
  {
    path: ROUTING.error + '/:errorHash?',
    name: 'Error',
    props: true,
    component: ErrorComponent,
    meta: {
      title: 'error',
    },
  },
  {
    path: ROUTING.confirmation,
    name: 'Confirmation',
    component: ConfirmationComponent,
    meta: {
      title: 'confirmation',
    },
  },
  {
    path: ROUTING.secureBack + '/:apiToken',
    name: 'SecureBack',
    props: true,
    component: SecureBackComponent,
    meta: {
      title: 'secureBack',
    },
  },
  {
    path: ROUTING.regulationsApproval + '/:idTransRemote/:continueHash',
    name: 'RegulationsApprovalContinue',
    props: true,
    component: RegulationsApprovalComponent,
    meta: {
      title: 'regulationsApproval',
    },
  },
  {
    path: ROUTING.regulationsApproval + '/:apiToken',
    name: 'RegulationsApprovalStart',
    props: true,
    component: RegulationsApprovalComponent,
    meta: {
      title: 'regulationsApproval',
    },
  },
  {
    path: ROUTING.sessionTimeout,
    name: 'SessionTimeout',
    component: SessionTimeoutComponent,
    meta: {
      title: 'sessionTimeout',
    },
  },
  {
    path: ROUTING.paywayError,
    name: 'paywayError',
    component: PaywayErrorComponent,
    meta: {
      title: 'paywayError',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: ROUTING.errorNotFound,
  },
]

export const pageTitle = () => {
  return {
    base: i18n.global.t('page.title.base'),
    start: i18n.global.t('page.title.start'),
    payerPaywall: i18n.global.t('page.title.payerPaywall'),
    result: i18n.global.t('page.title.result'),
    visadata: i18n.global.t('page.title.visadata'),
    continue: i18n.global.t('page.title.continue'),
    wait: i18n.global.t('page.title.wait'),
    confirmation: i18n.global.t('page.title.confirmation'),
    thankYou: i18n.global.t('page.title.thankYou'),
    error: i18n.global.t('page.title.error'),
    errorNotFound: i18n.global.t('page.title.errorNotFound'),
    secureBack: i18n.global.t('page.title.secureBack'),
    maintenance: i18n.global.t('page.title.maintenance'),
    regulationsApproval: i18n.global.t('page.title.regulationsApproval'),
    frData: i18n.global.t('page.title.toTransferData'),
    sessionTimeout: i18n.global.t('page.title.sessionTimeout'),
    paywayError: i18n.global.t('page.title.paywayError'),
  }
}
